import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getToken, decodeToken } from '../../utils/TokenUtils';
import { API_URL, ENDPOINTS } from '../../constants/api';
import axios from 'axios';
import sitcosbg from '../../images/sitcos.jpeg';

const PosInvoice = () => {
  const [data, setData] = useState([]);

  const styles = {
    container: {
      fontFamily: 'Roboto',
      width: '100%',
      padding: '10px',
      fontSize: '13px',
      color: 'black',
    },

    wrapper: {
      position: 'relative',
      minHeight: '20vh',
    },

    bgImage: {
       position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',  // ✅ PERFECT CENTER
  width: '100%',
  height: '100%',
  backgroundImage: `url(${sitcosbg})`,
  backgroundSize: '30%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  opacity: 0.08,
  zIndex: 0,
  pointerEvents: 'none',
    },

    content: {
      position: 'relative',
      zIndex: 1,
    },

    headerRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      marginBottom: '10px',
    },

    logo: {
      width: '70px',
      height: '70px',
      objectFit: 'contain',
    },

    companyText: {
      display: 'flex',
      flexDirection: 'column',
    },

    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: '10px',
    },

    thtd: {
      border: '1px solid black',
      padding: '5px',
      textAlign: 'left',
      fontSize: '12px',
    },

    footer: {
      textAlign: 'center',
      marginTop: '20px',
    },
  };

  const { route, id } = useParams();
  const token = getToken();

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/activityReport/${route}`;

    const fetchData = async () => {
      try {
        const response = await axios.post(
          url,
          { order_id: id, invoice_id: id },
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );

        setData(response.data.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [route]);

  const header = data?.find((d) => d.title === 'header')?.fields || {};
  const itemsData = data?.find((d) => d.title === 'items');

  const items = Array.isArray(itemsData?.table)
    ? itemsData.table
    : itemsData?.fields
    ? [itemsData.fields]
    : [];

  const payment = data?.find((d) => d.title === 'payment')?.fields || {};

  const companyName = decodeToken(token, 'companyName');
  const logo = decodeToken(token, 'logo');

  useEffect(() => {
    if (data.length > 0) {
      setTimeout(() => {
        window.print();
      }, 500);
    }
  }, [data]);

  return (
    <div style={styles.container}>
      
      {/* CONTENT WITH WATERMARK ONLY */}
      <div style={styles.wrapper}>
        
        {API_URL === 'https://sitcoscollegeapi.kaafi.net' && (
          <div style={styles.bgImage}></div>
        )}

        <div style={styles.content}>

          {/* HEADER */}
          <div style={styles.headerRow}>
            <img
              src={`${API_URL}/${logo}`}
              style={styles.logo}
              alt="logo"
            />
            <div style={styles.companyText}>
              <h3 style={{ margin: 0 }}>{companyName}</h3>
              <h4 style={{ margin: 0 }}>{header.invoice_title}</h4>
            </div>
          </div>

          {/* HEADER FIELDS */}
          <div className="row">
            {Object.entries(header)
              .filter(([key]) => key !== 'invoice_title')
              .map(([key, value], i) => {
                const [label] = key.split('~');
                return (
                  <div key={i} className="col-6">
                    <strong>{label}:</strong> {value}
                  </div>
                );
              })}
          </div>

          {/* TABLE */}
          <table style={styles.table}>
            <thead>
              <tr>
                {items.length > 0 &&
                  Object.keys(items[0]).map((head, i) => (
                    <th key={i} style={styles.thtd}>
                      {head}
                    </th>
                  ))}
              </tr>
            </thead>

            <tbody>
              {items.map((row, i) => (
                <tr key={i}>
                  {Object.values(row).map((val, j) => (
                    <td key={j} style={styles.thtd}>
                      {val}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          {/* PAYMENT */}
          <div style={{ marginTop: '10px' }}>
            {Object.entries(payment).map(([key, value], i) => (
              <p key={i} style={{ textAlign: 'right', margin: 0 }}>
                <strong>{key}:</strong> {value}
              </p>
            ))}
          </div>

        </div>
      </div>

      {/* ✅ FOOTER OUTSIDE WATERMARK */}
      <div style={styles.footer}>
        <p style={{ margin: 0 }}>Thank you!</p>
        <p style={{ margin: 0 }}>Powered by KTC</p>
      </div>

      {/* PRINT FIX */}
      <style>
        {`
          @media print {
            body {
              margin: 0;
            }

            table {
              page-break-inside: auto;
            }

            tr {
              page-break-inside: avoid;
            }

            .footer {
              page-break-before: avoid;
            }
          }
        `}
      </style>

    </div>
  );
};

export default PosInvoice;